import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button, Link, Stack} from '@customink/pigment-react';
import {useSelector} from 'react-redux';
import {isUploadFileSizeEnabled as isUploadFileSizeEnabledSelector} from '~/selectors/ConfigSelectors';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function UploadFilesizeError(props) {
  const {dismiss} = props;
  const isUploadFileSizeEnabled = useSelector(isUploadFileSizeEnabledSelector);
  const maxFileSize = isUploadFileSizeEnabled ? '20 MB' : '5 MB';

  return (
    <Notification
      {...props}
      title={
        <span>
          <span>Oops!</span> <span>Your file is too large.</span>
        </span>
      }>
      <p>
        Please resize your file to below {maxFileSize} or{' '}
        <span>
          <Link href="#/help" onClick={dismiss}>
            contact us
          </Link>{' '}
          for help.
        </span>
      </p>
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={dismiss}>
          Close
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

UploadFilesizeError.propTypes = propTypes;

UploadFilesizeError.displayName = 'UploadFilesizeError';
